import Confirm from 'components/confirm';
var {MODAL_PREFIX} = require('../../constants.js');
var React = require('react');
var ReactDOM = require('react-dom');

const MAKE_OWNER_MODAL = 'make-owner';
const MAKE_OWNER_MODAL_TRIGGER = MODAL_PREFIX + MAKE_OWNER_MODAL;

class MakeOwner extends React.Component {

  /**
   * @params props.organization
   * @params props.user
   */
  constructor(props) {
    super(props);
  }

  _changeOwner() {
    var ownerUrl = Routes.owner_organization_user_path(
      this.props.organization,
      this.props.user
    );
    var email = this.props.user.email;

    $.ajax({
      type: 'POST',
      url: ownerUrl,
      data: { _method: 'PUT' },
      success: function() {
        HRB.utils.notify("Great! " + email + " is now the new owner.");
        window.location.reload();
      },
      error: function(xhr, textStatus, error) {
        HRB.utils.notify("Sorry, it looks like changing the owner didn't work.",
                         {cssClass: 'error'});
      }
    });
  }

  _openModal(e) {
    e.preventDefault();
    $(ReactDOM.findDOMNode(this)).find('#' + MAKE_OWNER_MODAL_TRIGGER).modal();
  }

  render() {
    return (
      <div style={{display: "inline"}}>
        <a className="make-owner" href="#"
             onClick={this._openModal.bind(this)} >
              Make Owner
        </a>
        <Confirm id={MAKE_OWNER_MODAL}
                 title="Change owner"
                 message="This will change the owner of the organization."
                 onConfirm={this._changeOwner.bind(this)}
                 confirm_text="Yes, change owner" />
      </div>
    );
  }
}

module.exports = MakeOwner;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/organizations/make_owner.jsx